export default "__VITE_ASSET__jV0xqRN4__"